// extracted by mini-css-extract-plugin
export var indeterminate = "_49-6";
export var md = "_49-5";
export var semantic = "_49-7";
export var sm = "_49-4";
export var text = "_49-8";
export var toggleControl = "_49-0";
export var toggleInput = "_49-1";
export var toggleSwitch = "_49-2";
export var xs = "_49-3";